import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bfb48a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "root",
  class: "board-parent"
}
const _hoisted_2 = { class: "complete-board" }
const _hoisted_3 = { class: "complete-grid" }
const _hoisted_4 = { class: "complete-column" }
const _hoisted_5 = { class: "complete-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GreenboardOption = _resolveComponent("GreenboardOption")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_GreenboardOption, {
            optionHeader: '本体の色',
            optionValue: _ctx.body
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'へりの色',
            optionValue: _ctx.edge
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: '糸の色',
            optionValue: _ctx.thread
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'ふたの裏',
            optionValue: _ctx.inside
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'ポケット',
            optionValue: _ctx.pocket
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'よこ',
            optionValue: _ctx.side
          }, null, 8, ["optionValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'ふた',
            optionValue: _ctx.front
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'ふたの鋲',
            optionValue: _ctx.tack
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: '背中の色',
            optionValue: _ctx.back
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'ネーム',
            optionValue: _ctx.nameText
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'ネームの色',
            optionValue: _ctx.nameColor
          }, null, 8, ["optionValue"]),
          _createVNode(_component_GreenboardOption, {
            optionHeader: 'タイプ',
            optionValue: _ctx.bagsize,
            smallLatterSpacing: _ctx.getSmallLatterSpacing()
          }, null, 8, ["optionValue", "smallLatterSpacing"])
        ])
      ])
    ])
  ], 512))
}